'use client';

import { c as _c } from "react/compiler-runtime";
import type { Separator as SeparatorPrimitive } from 'radix-ui';
import type * as React from 'react';
import { Separator as ShadcnSeparator } from '@/components/ui/separator';
export type SeparatorProps = React.ComponentProps<typeof SeparatorPrimitive.Root>;
export function Separator(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ShadcnSeparator {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}